import React from 'react';
import { bool, number } from 'prop-types';
import classNames from 'classnames';
import Status from './Status';
import Footer from './Footer';
import Profile from './Profile';

import './style.scss';

const SellerCard = ({ id, isOnline = false, gigsCount, ...seller }) => {
    const { isUnavailable } = seller;

    const wrapperClass = classNames('seller-card', { unavailable: isUnavailable });

    return (
        <div className={wrapperClass}>
            <Profile avatarClassName="avatar" {...seller} isUnavailable={isUnavailable} />
            <Status isOnline={isOnline} isUnavailable={isUnavailable} />
            <Footer id={id} gigsCount={gigsCount} />
        </div>
    );
};

SellerCard.propTypes = {
    id: number,
    isOnline: bool,
    gigsCount: number,
};

export default SellerCard;
